import axios from "axios";

const MAX_FILES = 10;

export const uploadTempOwnerSilkImages = async (files, onUploadProgress) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("image", file));

  const response = await axios.post(
    `${window.env.API_URL}/owner-silk-images/temp-upload`,
    formData,
    {
      onUploadProgress,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  return response.data?.data || [];
};

export const deleteOwnerSilkImageById = async (imageId) => {
  await axios.delete(`${window.env.API_URL}/owner-silk-images/${imageId}`);
};

export const MAX_OWNER_SILK_IMAGES = MAX_FILES;
